/* eslint-disable complexity */
import {
  CrossIcon,
  ItasMinusIcon,
  ItasPlusIcon,
  RightArrowIcon,
  TickIcon,
} from "src/assets/";
import LandingAccordion from "src/ui/fragments/landing-accordion/Accordion";
import { Button } from "src/ui/widgets";
import { useSection2 } from "./section2.hook";
import { Image } from "react-bootstrap";
import React from "react";
import { CardInfoInclusionItem, CardInfoItem } from "src/types";
import { TranslationString } from "src/ui/widgets/mixed-translation-string/mixed-translation-string";

export const Section2 = () => {
  const {
    PACKAGE_BASE_PRICE,
    PACKAGE_PLUS_PRICE,
    selectedPackage,
    BASE_INCLUSIONS,
    PLUS_INCLUSIONS,
    CARD_INFO,
    t,
    setSelectedPackage,
    goToDataEntry,
    openInformativeSet,
  } = useSection2();

  const nextPage = (fromButton: string) =>
    goToDataEntry(fromButton === "base" ? true : false);

  const Title = (
    <h2 className="pt-4 mb-4 mb-md-5 ps-1 pe-1 landing-dynamic-size-title d-flex align-item-center justify-content-center">
      <div className="d-inline-block text-center">
        <div>{t("landing.section_2_title_1")}</div>
        <div className="ms-2 c-00686F">{t("landing.section_2_title_2")}</div>
      </div>
    </h2>
  );

  const Subtitle = (
    <div className="mb-5 landing-dynamic-size-desc d-flex align-items-center justify-content-center text-center">
      {t("landing.section_2_subtitle")}
    </div>
  );

  //Desktop

  const GuaranteesCard = (
    <div className="pt-4">
      <div className="section2-space-0">
        <div className="mb-4 section2-dynamic-column-title-nobold">
          {t("landing.section_2_guarantees_title")}
        </div>
      </div>

      {CARD_INFO.map((item, index) => (
        <div
          key={item.id}
          className={`ps-4 pe-4 d-flex align-items-center section2-space-${
            index + 1
          }`}
        >
          <div>
            <div className="pb-2 font-20-ag-500">{t(item.title)}</div>

            {item.subtitle && (
              <div className="pb-2 font-20-ag-400">{t(item.subtitle)}</div>
            )}

            <ul className="m-0 p-0 ps-4 pe-3 mt-2 mb-2">
              {item.infoList.map((key, i) => (
                <li key={i} className="font-16-ag-400 label-opacity-grey">
                  {t(key)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );

  const BaseCardDesktop = (
    <div className="pt-4">
      <div className="section2-space-0">
        <div className="mb-4">
          <div className="section2-dynamic-column-title">
            {t("commons.section_2_base_title")}
          </div>
        </div>

        <div>
          <div className="mb-4">
            <span className="font-36-age-700">{PACKAGE_BASE_PRICE}</span>
            <span className="font-16-ag-400">
              {t("landing.section_2_price_daily_label")}
            </span>
          </div>
          <div className="">
            <Button
              text={t("commons.active_now_button")}
              iconRight={RightArrowIcon}
              classes="justify-content-between primary-stretched"
              classesText="font-14-ag-500 text-uppercase"
              classesIconRight="filter-00686F"
              onPress={() => nextPage("base")}
            />
          </div>
        </div>
      </div>

      {CARD_INFO.map((item, index) => (
        <div
          key={index}
          className={`ps-4 pe-4 d-flex align-items-center justify-content-center section2-space-${
            index + 1
          }`}
        >
          <Image
            className="filter-00686F"
            src={
              BASE_INCLUSIONS.find((inc) => inc.id === item.id)?.isIncluded
                ? TickIcon
                : CrossIcon
            }
            width={32}
            height={32}
          />
        </div>
      ))}
    </div>
  );

  const PlusCardDesktop = (
    <div className="pt-4">
      <div className="section2-space-0">
        <div className="mb-4">
          <div className="section2-dynamic-column-title">
            {t("commons.section_2_plus_title")}
          </div>
        </div>

        <div>
          <div className="mb-4">
            <span className="font-36-age-700">{PACKAGE_PLUS_PRICE}</span>
            <span className="font-16-ag-400">
              {t("landing.section_2_price_daily_label")}
            </span>
          </div>
          <div className="">
            <Button
              text={t("commons.active_now_button")}
              iconRight={RightArrowIcon}
              classes="justify-content-between primary-stretched"
              classesText="font-14-ag-500 text-uppercase"
              classesIconRight="filter-00686F"
              onPress={() => nextPage("plus")}
            />
          </div>
        </div>
      </div>

      {CARD_INFO.map((item, index) => (
        <div
          key={item.id}
          className={`ps-4 pe-4 d-flex align-items-center justify-content-center section2-space-${
            index + 1
          }`}
        >
          <Image
            className="filter-00686F"
            src={
              PLUS_INCLUSIONS.find((inc) => inc.id === item.id)?.isIncluded
                ? TickIcon
                : CrossIcon
            }
            width={32}
            height={32}
          />
        </div>
      ))}
    </div>
  );

  const PackagesDesktop = (
    <div className="d-none d-xl-block">
      <div className="ms-lg-4 me-lg-4 mb-4 d-flex align-items-center justify-content-center">
        <div className="col-md-12 row gx-4 m-0 p-0">
          <div className="col-md-4">
            <div className="section2-card">{GuaranteesCard}</div>
          </div>
          <div className="col-md-4" onClick={() => setSelectedPackage("base")}>
            <div
              className={`cursor-pointer ${
                selectedPackage === "base"
                  ? "selected-package"
                  : "section2-card"
              }`}
            >
              {BaseCardDesktop}
            </div>
          </div>
          <div className="col-md-4" onClick={() => setSelectedPackage("plus")}>
            <div
              className={`cursor-pointer ${
                selectedPackage === "plus"
                  ? "selected-package"
                  : "section2-card"
              }`}
            >
              {PlusCardDesktop}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  //Mobile
  const CardMobileContent = ({
    info,
    inclusions,
  }: {
    info: CardInfoItem[];
    inclusions: CardInfoInclusionItem[];
  }) => {
    return (
      <>
        {info.map((item) => (
          <React.Fragment key={item.id}>
            <div className="mt-4 mb-4 ps-4 pe-4">
              <LandingAccordion
                icon_size={18}
                icon_open={ItasMinusIcon}
                icon_close={ItasPlusIcon}
                show_close={true}
                button_read={false}
                classes="ps-md-3 pe-md-3"
                classes_icon_open="section2-open-icon filter-00686F"
                classes_icon_close="filter-00686F"
                head={
                  <div className="font-16-ag-400 d-flex align-items-center">
                    {inclusions.find((inc) => inc.id === item.id)
                      ?.isIncluded ? (
                      <Image
                        className="filter-00686F"
                        src={TickIcon}
                        width={20}
                        height={18}
                      />
                    ) : (
                      <Image
                        className="filter-00686F"
                        src={CrossIcon}
                        width={16}
                        height={18}
                      />
                    )}

                    <div className="ms-2">{t(item.title)}</div>
                  </div>
                }
              >
                <>
                  {item.subtitle && (
                    <div className="pt-3 pb-2 font-14-ag-500">
                      {t(item.subtitle)}
                    </div>
                  )}
                  <ul className="pt-2 ps-4 pe-3">
                    {item.infoList.map((infoKey, i) => (
                      <li key={i} className="font-14-ag-400 label-opacity-grey">
                        {t(infoKey)}
                      </li>
                    ))}
                  </ul>
                </>
              </LandingAccordion>
            </div>
            <hr className="ms-4 me-4 section2-separator" />
          </React.Fragment>
        ))}
      </>
    );
  };

  const BaseCardMobile = (
    <div className="pt-4 pb-4">
      <div className="ps-4 pe-4">
        <div className="section2-dynamic-column-title mb-3">
          {t("commons.section_2_base_title")}
        </div>
      </div>
      <div className="ps-4 pe-4 font-24-age-700">{PACKAGE_BASE_PRICE}</div>
      <div className="mt-3 ps-4 pe-4">
        <Button
          text={t("commons.active_now_button")}
          iconRight={RightArrowIcon}
          classes="justify-content-between primary-stretched"
          classesText="font-10-ag-500 text-uppercase"
          classesIconRight="filter-00686F"
          onPress={() => nextPage("base")}
        />
      </div>

      <CardMobileContent info={CARD_INFO} inclusions={BASE_INCLUSIONS} />
    </div>
  );

  const PlusCardMobile = (
    <div className="pt-4 pb-4">
      <div className="ps-4 pe-4">
        <div className="section2-dynamic-column-title mb-3">
          {t("commons.section_2_plus_title")}
        </div>
      </div>
      <div className="ps-4 pe-4 font-24-age-700">{PACKAGE_PLUS_PRICE}</div>
      <div className="mt-3 ps-4 pe-4">
        <Button
          text={t("commons.active_now_button")}
          iconRight={RightArrowIcon}
          classes="justify-content-between primary-stretched"
          classesText="font-10-ag-500 text-uppercase"
          classesIconRight="filter-00686F"
          onPress={() => nextPage("plus")}
        />
      </div>

      <CardMobileContent info={CARD_INFO} inclusions={PLUS_INCLUSIONS} />
    </div>
  );

  const PackagesMobile = (
    <div className="d-block d-xl-none">
      <div>
        <div className="row gx-4 mb-4">
          <div onClick={() => setSelectedPackage("base")}>
            <div
              className={`cursor-pointer ${
                selectedPackage === "base"
                  ? "selected-package"
                  : "section2-card"
              }`}
            >
              {BaseCardMobile}
            </div>
          </div>

          <div className="mt-4" onClick={() => setSelectedPackage("plus")}>
            <div
              className={`cursor-pointer ${
                selectedPackage === "plus"
                  ? "selected-package"
                  : "section2-card"
              }`}
            >
              {PlusCardMobile}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const InformativeSetCTA = (
    <div className="informative-cta">
      <TranslationString
        i18nKey="landing.section_2_read_informative_set"
        underline
        onClick={openInformativeSet}
      />
    </div>
  );

  return (
    <div>
      {Title}
      {Subtitle}
      {PackagesDesktop}
      {PackagesMobile}
      {InformativeSetCTA}
    </div>
  );
};
